import { getSentry } from './index';
import { isReplayIntegration } from './types';

let replayStopped = false;

export const stopReplay = (reason: string) => {
  if (replayStopped) return;

  const Sentry = getSentry();
  if (!Sentry) return;

  const client = Sentry.getClient();
  const replay = client?.getIntegrationByName?.('Replay');

  if (isReplayIntegration(replay)) {
    replayStopped = true;

    Sentry.setTag('replay.stop_reason', reason);
    replay.stop();
  }
};
